export type TimSkillId = "GridIncreaseTim" | "GridIncreaseTim2";

export interface TimSkillDefinition {
  readonly id: TimSkillId;
  readonly costTim: number;
  readonly prerequisites: readonly TimSkillId[];
  readonly position: { readonly row: number; readonly col: number };
}

export const TIM_SKILL_DEFINITIONS: readonly TimSkillDefinition[] = [
  {
    id: "GridIncreaseTim",
    costTim: 10000,
    prerequisites: [],
    position: { row: 0, col: 0 },
  },
  {
    id: "GridIncreaseTim2",
    costTim: 40000,
    prerequisites: ["GridIncreaseTim"],
    position: { row: 1, col: 0 },
  },
];

export const TIM_SKILL_HOLD_MS = 3000;

const TIM_SKILL_IDS = new Set<TimSkillId>(
  TIM_SKILL_DEFINITIONS.map((definition) => definition.id),
);

export function isTimSkillId(value: string): value is TimSkillId {
  return TIM_SKILL_IDS.has(value as TimSkillId);
}

export function getTimSkillDefinition(id: TimSkillId): TimSkillDefinition {
  const def = TIM_SKILL_DEFINITIONS.find((d) => d.id === id);
  if (!def) {
    throw new Error(`Unknown tim skill id: ${id}`);
  }
  return def;
}
